// extracted by mini-css-extract-plugin
export default {"screen_container":"ThankYouScreen_screen_container__mYSLQ","block_spacer":"ThankYouScreen_block_spacer__FUwzy"};